import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { version } from 'src/version';
import { Context } from '../context';
import { AuthService } from '../services/auth.service'; // Adjust the path as needed

@Injectable()
export class TokenAuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    // Set up headers
    const headers: any = { 'X-App-Version': version };
    if (Context.authToken) {
      headers.Authorization = `Bearer ${Context.authToken}`;
    }

    // Clone the request with the new headers
    request = request.clone({ setHeaders: headers });

    // Handle the request and process responses
    return next.handle(request).pipe(
      tap(event => {
        // Check if the event is an HttpResponse
        if (event instanceof HttpResponse) {
          // Look for the 'X-New-Token' header
          const newToken = event.headers.get('X-New-Token');
          if (newToken) {
            // Update the token using AuthService
            this.authService.setToken(newToken);
          }
        }
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          // Call the logout method on AuthService
          this.authService.signOut();
        }
        // Rethrow the error so that other parts of the app can handle it
        return throwError(() => error);
      })
    );
  }
}
